export const externalPaths = {
	affiliates: {
		hdLink: "360000054720",
		previewLink: "https://bitpanda-broker-production-assets.s3-eu-west-1.amazonaws.com/affiliate/"
	},
	tradeOffer: {
		hodlLink: "360000046479",
		singleAccount: "%s/legal#single-account"
	},
	fagg_11: {
		hdLink: "/legal/bitpanda-general-terms-conditions#withdrawal",
		hdGroupLink: "/legal/bitpanda-group-general-terms-conditions#withdrawal"
	},
	privacyPolicy: {
		link: "/legal/bitpanda-privacy-policy"
	},
	cryptoQr: {
		hdLink: "360001657820"
	},
	bestFeeCollection: {
		hdLink: {
			en: "360006113199#benefits",
			de: "360006113199#vorteile",
			fr: "360006113199#avantages",
			es: "360006113199#ventajas"
		},
		widget: "best/rewards"
	},
	appLinks: {
		eng: "/app-ios-android",
		deu: "/app-ios-android",
		spa: "/funciones/app-aplicacion-inversion-ios-android",
		fra: "/fonctionnalites/app-investissement-ios-android",
		pol: "/aplikacja-ios-android",
		tur: "/urunler/bitpanda-indir",
		ita: "/app-applicazione-ios-android",
		hrv: "/app-ios-android",
		ron: "/app-ios-android",
		hun: "/app-ios-android",
		ces: "/app-ios-android",
		nld: "/app-ios-android"
	},
	legalLinks: {
		eng: "/legal/legal-notice",
		deu: "/rechtliches/impressum",
		spa: "/legal/aviso-legal",
		fra: "/legal/mentions-legales",
		pol: "/prawne/informacja-prawna",
		tur: "/yasal/yasal-uyari",
		ita: "/legale/avviso-legale",
		hrv: "/legal/legal-notice",
		ron: "/legal/legal-notice",
		hun: "/legal/legal-notice",
		ces: "/legal/legal-notice",
		nld: "/legal/legal-notice"
	},
	taf: {
		hdLink: "115002576209"
	},
	info_integration: {
		hdLink: "360003779200"
	},
	crypto_withdraw: {
		hdLink: "360001520940"
	},
	fiat_withdraw: {
		hdLink: "360006315499"
	},
	fiat_send: {
		hdLink: "360004753460"
	},
	deposit: {
		tooltip: "360000116459"
	},
	send: {
		tooltip_fee: "360000902805",
		tooltip_contact: "360000902845",
		switchSend: "360000902045",
		onlineScam: "360001414160"
	},
	savings: {
		hdLink: "%s/legal#savings"
	},
	withdrawal: {
		hdLink: "360006315499"
	},
	user2FA: {
		hdLink: "360000828665"
	},
	userSupportEmail: {
		hdLink: "360001235425"
	},
	best: {
		perksLink: "%s/best#rewards",
		best_two_hdLink: "360006113199",
		best_two_legal: "/legal/bitpanda-ecosystem-token-best-2-0-terms-explanatory-notes",
		best_two_loyalty_program: "/legal/bitpanda-loyalty-program-best-terms-explanatory-notes"
	},
	payments: {
		termsLink: "%s/legal#terms-payments",
		policyLink: "%s/legal#privacy-payments"
	},
	commodities: {
		storageFeesLink: "%s/limits#storagefees"
	},
	mobileApps: {
		bundleId: "com.bitpanda.bitpanda",
		androidUrl: "https://play.google.com/store/apps/details?id=com.bitpanda.bitpanda",
		iosUrl: "https://apps.apple.com/at/app/bitpanda-buy-bitcoin-crypto/id1449018960"
	},
	verification: {
		onfido: {
			failedLink: "360000996469"
		},
		hdLink: "360000996469"
	},
	index: {
		prospectus: "%s/bci-bitpanda-crypto-index#legal",
		indexOnly: "360015932880",
		readMore: "/bci-bitpanda-crypto-index"
	},
	aml: {
		hdLink: "360010863959"
	},
	card: {
		bestUrl: "%s/card/benefits",
		cardUrl: "%s/card",
		termsUrl: "%s/legal#terms-contis",
		contisUrl: "%s/legal#privacy-contis"
	},
	stocks: {
		toggle: {
			contract: "%s/",
			cost: "%s/",
			prospectus: "%s/",
			investor: "%s/"
		},
		analystRating: {
			hdLink: "360019845080"
		}
	},
	tradeTerms: {
		stocks: "stocks/",
		etfs: "etfs/",
		etcs: "etcs/",
		security: "security-tokens/",
	},
	sar: {
		hdLink: "360000905229"
	},
	statusUrl: "https://status.bitpanda.com/",
	helpdeskWidgets: {
		elevio: {
			enabled: true,
			accountId: "5fb0acf32b4da"
		}
	},
	firebase: {
		shortLinksUrl: "https://firebasedynamiclinks.googleapis.com/v1/shortLinks",
		domainPrefix: "https://bitpanda.page.link"
	},
	reddit: {
		url: "https://www.reddit.com/submit"
	},
	facebook: {
		url: "https://www.facebook.com/sharer/sharer.php"
	},
	linkedin: {
		url: "https://www.linkedin.com/sharing/share-offsite/"
	},
	twitter: {
		url: "https://twitter.com/intent/tweet"
	},
	leveragedAssets: {
		hdLink: "6242864492572",
		shortTerms: "/legal/terms-short",
		longTerms: "/legal/terms-long",
		faqLink: "/bitpanda-leverage#faq"
	},
	securityTokens: {
		terms: "prices/security-tokens/steelcoin-steel"
	},
	pof: {
		link: "360010477679",
		supportFiat: "new?PofFiatB2C=1",
		supportCrypto: "new?PofCryptoB2C=1"
	},
	academyLink: {
		eng: "academy/en",
		deu: "academy/de",
		spa: "academy/es",
		fra: "academy/fr",
		pol: "academy/pl",
		ita: "academy/it"
	},
	riskLink: {
		en: "en/legal/risk-disclosures",
		de: "de/legal/risikohinweise"
	},
	launchpad: {
		hdLink: "7826669925404"
	},
	staking: {
		lockedStakingHdLink: "8324987568284",
		staking: "/staking"
	},
	bitpanda_club: {
		club_member_link: "/bitpanda-club"
	},
	bitpanda_cash_plus: {
		link: "bitpanda-cash-plus"
	},
	cashPlus_doc: {
		download: "/bitpanda-cash-plus#downloads"
	},
	taxes: {
		hdLink: "10116161132188"
	},
	supported_countries: {
		hdLink: "360013898239"
	},
	// Both needed for UK
	uk_finprom_risk_warning: {
		link: "en/legal/uk-finprom-risk-warning"
	},
	uk_finprom_risk_summary: {
		link: "legal/uk-finprom-crypto-class-specific-risk-warnings"
	},
	travel_rule: {
		faq: "https://bitpanda.com/travel-rule/faq"
	},
	solaris: {
		hdLink: "360000905749"
	}
};
